import { render } from "./PlanningHolidays.vue?vue&type=template&id=24c2e2ec&scoped=true"
import script from "./PlanningHolidays.vue?vue&type=script&lang=js"
export * from "./PlanningHolidays.vue?vue&type=script&lang=js"

import "./PlanningHolidays.vue?vue&type=style&index=0&id=24c2e2ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c2e2ec"]])

export default __exports__